<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="fa fa-money"></i> Pagamentos
                <b-link :to="actionUri" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-angle-left"></i>
                  Voltar
                </b-link>
            </div>
            <b-card-body>
                <h4>Solicitante</h4>
                <hr class="mb-5" />
                <form @submit.prevent="validate" class="needs-validation" novalidate>
                    <div class="form-row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label>{{getRequesterType}}</label>
                                <input disabled type="text" v-model="model.customerName" class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label>Documento</label>
                                <input disabled type="text" v-model="document"  class="form-control-plaintext" />                                
                            </div>
                        </div>
                    </div>
                    <h4 class="mt-5">Valor do pagamento</h4>
                    <hr class="mb-5" />
                    <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
                    <div class="form-row justify-content-start">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Valor</label>
                                <vue-numeric
                                    :separator="vueNumericDefaults.separator"
                                    :precision="vueNumericDefaults.decimals"
                                    :output-type="vueNumericDefaults.outputType"                                    
                                    v-model="model.amount"
                                    disabled
                                    class="form-control-plaintext"
                                />                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Data agendamento</label>
                                <input disabled type="text" class="form-control-plaintext" v-model="model.scheduledDate" />
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Status Atual</label>
                                <input disabled type="text" class="form-control-plaintext" :value="getStatusName" />
                            </div>
                        </div>
                        <template v-if="$auth.isPartner || $auth.isFinance">
                            <template v-if="model.moneyOutGroupId != ''">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{model.moneyOutGroupName}}</label>
                                        <div class="form-control-plaintext"><a :href="moneyOutGroupLink"><strong>Ver remessa</strong></a></div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="col-sm-3" v-if="model.status != 'DONE' && model.status != 'CANCELED'"> 
                                    <div class="form-group">
                                        <label>Alterar Status</label>
                                        <select :class="{'custom-select': true}" v-model="newStatus">
                                            <option v-for="(s, index) in paymentStatusSelectList" :key="index" :value="s.id">
                                                {{s.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <div class="col-sm-3" v-if="model.status == 'PENDING' && model.status != 'ANALYSIS'"> 
                               <button type="button" @click="cancelPayment" class="btn btn-primary">Cancelar</button>
                            </div>
                        </template>
                    </div> 
                    <div class="form-row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label>Observação</label>
                                <textarea disabled class="form-control-plaintext" v-model="model.description" id="textarea-input" name="textarea-input" rows="3" placeholder=""></textarea>
                            </div>
                        </div>
                    </div>               
                    <h4 class="mt-5">{{paymentMethodType}}</h4>
                    <hr class="mb-5" />
                    <div v-show="model.type == 'WITHDRAW' || model.type == 'BANKTRANSFER'">
                        <bank-account v-model="bankAccount" :action="action" :disabled="true" />
                    </div>
                    <div v-show="model.type == 'BILLPAYMENT'">
                        <div class="form-row">
                            <div class="col-sm-4">
                                <base-input disabled type="text" label="Favorecido" required placeholder="" v-model="billPayment.recipientName" data-vv-name="billPayment.recipientName" data-vv-as="favorecido" maxlength="255" :error="getError('billPayment.recipientName')" />
                            </div>
                            <div class="col-sm-4">
                                <base-input disabled required label="Cnpj / Cpf Emissor" type="tel" placeholder="" v-model="billPayment.recipientDocument" data-vv-name="billPayment.recipientDocument" data-vv-as="cpf/cnpj" :mask="['###.###.###-##', '##.###.###/####-##']" :error="getError('billPayment.recipientDocument')" />
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label for="exampleFormControlSelect1">Tipo Boleto</label>
                                    <select disabled :class="{'form-control': true, 'is-invalid': errors.has('type')}" v-model="billPayment.documentType" data-vv-name="billPayment.documentType" data-vv-as="tipo">
                                        <option v-for="(s, index) in billPaymentTypeList" :key="index" :value="s.value">
                                            {{s.text}}
                                        </option>
                                    </select>
                                    <div v-show="errors.has('billPayment.documentType')" class="invalid-feedback">
                                        {{ errors.first('billPayment.documentType') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-8">
                                <base-input disabled type="text" label="Código boleto" required placeholder="" v-model="billPayment.barCode" data-vv-name="billPayment.barCode" data-vv-as="Codigo boleto" maxlength="255" :error="getError('billPayment.barCode')" />
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label>Vencimento</label>
                                    <input disabled type="text" class="form-control-plaintext" v-model="billPayment.dueDateAt" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="model.type == 'PIXTRANSFER'">
                        <div class="form-row">
                            <div class="col-sm-12">
                                <base-input disabled type="text" label="Favorecido" required placeholder="" v-model="pixTransfer.recipientName" data-vv-name="pixTransfer.recipientName" data-vv-as="Favorecido" maxlength="255" :error="getError('pixTransfer.recipientName')" />
                            </div>                            
                        </div>
                        <div class="form-row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label for="exampleFormControlSelect1">Tipo de chave</label>
                                    <select disabled :class="{'form-control': true, 'is-invalid': errors.has('keyType')}" v-model="pixTransfer.keyType" data-vv-name="pixTransfer.keyType" data-vv-as="tipo de chave">
                                        <option v-for="(s, index) in pixKeyTypeList" :key="index" :value="s.value">
                                            {{s.text}}
                                        </option>
                                    </select>
                                    <div v-show="errors.has('pixTransfer.keyType')" class="invalid-feedback">
                                        {{ errors.first('pixTransfer.keyType') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-8">
                                <base-input disabled type="text" label="Chave Pix" required placeholder="" v-model="pixTransfer.pixKey" data-vv-name="pixTransfer.pixKey" data-vv-as="Chave Pix" maxlength="255" :error="getError('pixTransfer.pixKey')" />
                            </div>                            
                        </div>                        
                    </div>
                    <template v-if="(model.status == 'PROCESSING') && (model.type == 'PIXTRANSFER' || model.type == 'BILLPAYMENT') && ($auth.isPartner || $auth.isFinance)">
                        <h4 class="mt-5">Transfeera</h4>
                        <hr class="mb-5" />
                        <template v-if="model.authorizationCode == null || model.authorizationCode == ''">
                            <div class="form-row mb-3">
                                <div class="col-sm-12">
                                    Clique no botão abaixo para iniciar o processo de pagamento via Transfeera.
                                </div>
                            </div>
                            <button v-if="$auth.isPartner  || $auth.isFinance" type="button" @click="makePayment" class="btn btn-primary">REALIZAR PAGAMENTO</button>
                        </template>
                        <template v-else>
                            <div class="form-row">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>Data Pagamento</label>
                                        <input disabled type="text" class="form-control-plaintext" v-model="pixTransferResponse.payment_date" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>Status Atual</label>
                                        <input disabled type="text" class="form-control-plaintext" :value="pixTransferResponse.status" />
                                    </div>
                                </div>
                            </div>
                            <template v-if="model.status == 'PROCESSING'">
                                <button v-if="$auth.isPartner  || $auth.isFinance" type="button" @click="getPaymentTransferStatus" class="btn btn-primary mb-5">ATUALIZAR STATUS</button>    
                            </template>                            
                        </template>                                                
                    </template>
                    <template v-if="model.status == 'DONE' || newStatus == 'DONE'">
                        <h4 class="mt-5">Comprovantes <a v-if="$auth.isPartner || $auth.isFinance" href="javascript:void(0);" class="btn btn-sm btn-primary" @click="showUploadModal = true"><i class="fa fa-plus"></i></a></h4>
                        <hr class="mb-5" />
                        <div class="form-row">
                            <div class="col-sm-12">
                                <b-table ref="table" show-empty :dark="false" :busy="tableLoading" :hover="false" :striped="true" :bordered="false" :small="false" :fixed="false" responsive :items="model.attachments" :fields="tableFields">
                                    <div slot="table-busy" class="text-center text-danger my-2">
                                        <b-spinner class="m-2 align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                    <template slot="actions" slot-scope="row">
                                        <a class="btn mr-2 btn-md btn-info action-btn" :href="row.item.uriPath" target="_blank">
                                            <i class="fa fa-file"></i>
                                        </a>
                                        <button v-if="$auth.isPartner || $auth.isFinance" class="btn mr-2 btn-md btn-info action-btn" @click.prevent="onCustomActionClick(row)">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                        <button v-if="$auth.isPartner || $auth.isFinance" type="button" @click="saveAttachments" class="btn btn-primary">Salvar</button>
                    </template>                          
                    <h4 class="mt-5">Historico</h4>
                    <c-table :table-data="tableData" :fields="fields" striped></c-table>
                    <hr class="mt-5" />
                    <template v-if="model.status == 'CANCELED'">
                        <b-link :to="actionUri" class="btn mr-2 btn-sm btn-primary">
                            <i class="fa fa-angle-left"></i>
                            Voltar
                        </b-link>
                    </template>
                    <template v-else>                        
                        <button v-if="$auth.isPartner" type="submit" class="btn btn-primary">Salvar</button>
                    </template>
                </form>
            </b-card-body>
        </b-card>        
        <b-modal
          id="modal-upload"
          ref="modal"
          title="Adicionar Comprovante"
          @hidden="resetUploadModal"
          @ok="handleUploadOk"
          ok-title="Salvar"
          cancel-title="Cancelar"
          v-model="showUploadModal">
          <form ref="form">
            <div class="form-row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <file-upload :accept="'.pdf,.png,.jpg'" :url='uploadModal.url' :headers="uploadModal.headers" btnLabel="Selecione um arquivo" btnUploadingLabel="Enviando arquivos..." @change="onFileChange"></file-upload>
                    </div>
                </div>
            </div>
          </form>
        </b-modal>
    </div>
</template>
<script>
import domainService from '../../../services/MoneyFlow/moneyOutService'
import editPage from '../../../mixins/editPage'
import cTable from '../../../components/base/Table.vue'
import _ from 'lodash'
import config from '../../../config'
import BankAccount from '../../../components/customers/bankAccount.vue'
import moment from 'moment'
import { getInstance } from '../../../auth/authWrapper'
import * as lang from "vuejs-datepicker/src/locale"
export default {
    components: {
        cTable,
        BankAccount
    },
    props: {
        id: String
    },
    mixins: [editPage],
    data() {
        return {
            languages: lang,
            actionUri: '/partners/payments',
            newStatus: '',
            vueNumericDefaults: {
                decimals: 2,
                separator: '.',
                outputType: 'Number'
            },
            uploadModal: {
                fileName: '',
                uriPath: '',
                errorMessage: '',
                hasError: true,
                url: `${config.apiEndpoints.moneyOutUri}upload`,
                headers: {}
            },            
            showUploadModal: false,
            tableLoading: false,
            tableFields: [
                {key: 'fileName', label: 'Arquivo', sortable: false},
                {key: 'description', label: 'Descrição', sortable: false},
                {key: 'actions', label: ''}
            ],
            bankAccount: this.getEmptyBankAccount(),
            billPayment: this.getEmptyBillPayment(),
            pixTransfer: this.getEmptyPixTransfer(),
            model: this.getEmptyModel(),
            pixTransferResponse: {},
            fields: [
                {key: 'updatedAt', label: 'Data', sortable: false},
                {key: 'status', label: 'Status', sortable: false},
                {key: 'description', label: 'Descrição', sortable: false},
                {key: 'userName', label: 'Usuario', sortable: false},
            ],
            paymentStatusSelectList:[                
                {
                    id: '',
                    name: ''
                }
            ],
            paymentStatusList:[
                {id: "PENDING", name: "Pendente"},
                {id: "ANALYSIS", name: "Em análise"},
                {id: "PROCESSING", name: "Processando"},
                {id: "DONE", name: "Finalizado"},
                {id: "CANCELED", name: "Cancelado"},
            ],
            billPaymentTypeList: [
                {
                    value: '1',
                    text: 'Bancário'
                },
                {
                    value: '2',
                    text: 'Água / Luz'
                },
                {
                    value: '3',
                    text: 'Outro'
                }
            ],
            pixKeyTypeList: [
                {
                    value: 'DOCUMENTNUMBER',
                    text: 'CPF / CNPJ'
                },
                {
                    value: 'PHONE',
                    text: 'Telefone'
                },
                {
                    value: 'EMAIL',
                    text: 'Email'
                },
                {
                    value: 'RANDOM',
                    text: 'Aleatória'
                },
                {
                    value: 'UNKNOWN',
                    text: ''
                }
            ],
            tableData: {
                pageIndex: 0,
                pageCount: 0,
                tableCount: 0,
                data: []
            }
        }
    },
    created(){
        if(this.$auth.isSeller || this.$auth.isSalesPerson){
            this.fields = this.fields.slice(0, 3);
        }
        this.fetchData()
    },
    computed: {
        moneyOutGroupLink() {
            return `/partners/paymentgroups/edit/${this.model.moneyOutGroupId}`;
        },
        action() {
            return this.$route.name
        },
        getStatusName: function() {
            const self = this
            let s = _.find(this.paymentStatusList, function(o) { return o.id == self.model.status })
            return s ? s.name : ''
        },
        
        getRequesterType: function() {
            return this.model.customerType == 'SELLER' ? 'Empresa' : 'Representante'
        },
        paymentMethodType() {
            switch (this.model.type)
            {
                case 'BANKTRANSFER':
                    return 'Transferência';
                case 'BILLPAYMENT':
                    return 'Boleto';
                case 'WITHDRAW':
                    return 'Saque - Conta Titular';
                case 'PIXTRANSFER':
                    return 'Pix';
            }
        },
        document() {
            return this.action == 'view_withdraw' || 'view_banktransfer' ? this.bankAccount.document : this.billPayment.recipientDocument
        }
    },
    methods: {
        getEmptyModel() {
            return {
                amount: 0,
                scheduledDate: new Date(),
                type: 'WITHDRAW',
                description: '',
                status: '',
                moneyOutGroupId: '',
                moneyOutGroupName: '',
                authorizationCode: '',
                attachments: []
            }            
        },
        getEmptyBankAccount() {
            return {
                owner: '',
                document: '',
                number: '',
                branchNumber: '',
                documentType: '',
                bankCode: null,
                type: null,
                pagBankEmail: '',
                customerId: '',
                status: 'ACTIVE'
            }
        },
        getEmptyBillPayment() {
            return {
                dueDateAt: new Date(),
                recipientName: '',
                recipientDocument: '',
                documentType: '1',
                barCode: ''
            }
        },
        getEmptyPixTransfer() {
            return {
                pixKey: '',
                recipientName: '',
                keyType: 'UNKNOWN'
            }
        },
        bindPaymentStatusList() {
            const self = this;
            
            const start = this.model.status == 'CANCELED' ? 4 : this.paymentStatusList.findIndex(function(item) { return item.id == self.model.status }) + 1;            
            this.paymentStatusSelectList.pop()
            for(let i = start; i <= 4; i++) {
                this.paymentStatusSelectList.push(this.paymentStatusList[i])
            }
            this.newStatus = this.paymentStatusSelectList[0].id
        },
        async fetchData() {
            const self = this
            
            let authService = getInstance();
            let token = await authService.getTokenSilently();
            self.uploadModal.headers = {'Authorization': `Bearer ${token}`}

            self.showLoading();
            let svc = {};
            if(this.action == 'view_withdraw') {
                svc = domainService.findWithDraw(this.id);
            }
            if(this.action == 'view_banktransfer') {
                svc = domainService.findBankTransfer(this.id);
            }
            if(this.action == 'view_billpayment') {
                svc = domainService.findBillPayment(this.id);
            }
            if(this.action == 'view_pixtransfer') {
                svc = domainService.findPixTransfer(this.id);
            }
            svc.then((response) => {
                self.model = {
                    amount: response.data.amount,
                    scheduledDate: moment(response.data.scheduledDate).format('DD/MM/YYYY - HH:mm:ss'),
                    type: '',
                    description: response.data.description,
                    customerName: response.data.customerName,
                    customerId: response.data.customerId,
                    customerType: response.data.customerType,
                    status: response.data.status,
                    moneyOutGroupName: response.data.moneyOutGroupName,
                    moneyOutGroupId: response.data.moneyOutGroupId == null || response.data.moneyOutGroupId == undefined ? '' : response.data.moneyOutGroupId,
                    attachments: response.data.attachments,
                    authorizationCode: response.data.authorizationCode
                }

                if(this.action == 'view_withdraw' || this.action == 'view_banktransfer') {
                    self.model.type = this.action == 'view_banktransfer' ? 'BANKTRANSFER' : 'WITHDRAW';
                    self.bankAccount = {
                        owner: response.data.owner,
                        document: response.data.document,
                        number: response.data.number,
                        branchNumber: response.data.branchNumber,
                        documentType: response.data.documentType,
                        bankCode: response.data.bankCode,
                        type: response.data.accountType,
                        pagBankEmail: response.data.pagBankEmail,
                        customerId: response.data.customerId,
                        status: 'ACTIVE'
                    }
                }

                if(this.action == 'view_billpayment') {
                    self.model.type = 'BILLPAYMENT';
                    self.billPayment = {
                        dueDateAt: moment(response.data.dueDateAt).format('DD/MM/YYYY - HH:mm:ss'),
                        recipientName: response.data.recipientName,
                        recipientDocument: response.data.recipientDocument,
                        documentType: response.data.documentType,
                        barCode: response.data.barCode
                    }
                }
                
                if(this.action == 'view_pixtransfer') {
                    self.model.type = 'PIXTRANSFER';
                    self.pixTransfer = {
                        pixKey: response.data.pixKey,
                        recipientName: response.data.recipientName,
                        keyType: response.data.keyType
                    }
                }

                self.tableData.data = response.data.statusHistories
                self.bindPaymentStatusList()
                self.hideLoading()
            })
        },
        makePayment(){
            const self = this
            self.showLoading()
            domainService.makePayment({moneyOutId: self.id, moneyOutType: self.model.type}).then((response) => {
                self.pixTransferResponse = response.data;                
                self.hideLoading()
                self.fetchData();
            },
            error => {
                self.hideLoading()
                self.showError(error.response.data.message)
            });
        },
        getPaymentTransferStatus() {
            const self = this
            self.showLoading()
            domainService.getPaymentStatus(self.id, this.action == 'view_pixtransfer').then((response) => {
                self.pixTransferResponse = response.data;
                self.pixTransferResponse.payment_date = moment(response.data.payment_date).format('DD/MM/YYYY - HH:mm:ss')                
                self.hideLoading()
                self.fetchData();
            },
            error => {
                self.hideLoading()
                self.showError(error.response.data.message)
            });
        },
        validate() {
            // if (this.newStatus == 'CANCELED') {
            //     this.showPasswordModal = true
            //     return
            // }
            const self = this
            self.showLoading()
            domainService.updateStatus({id: self.id, status: self.newStatus}).then(() => {
                self.hideLoading()
                self.$router.push({ path:self.actionUri })
            },
            error => {
                self.hideLoading()
                self.showError(error.response.data.message)
            });
        },
        cancelPayment() {
            const self = this
            self.showLoading()
            domainService.updateStatus({id: self.id, status: 'CANCELED'}).then(() => {
                self.hideLoading()
                self.$router.push({ path:self.actionUri })
            },
            error => {
                self.hideLoading()
                self.showError(error.response.data.message)
            });
        },
        onFileChange (file) {
            this.uploadModal.fileName = file.fileName
            this.uploadModal.uriPath = file.uriPath
        },        
        resetUploadModal() {
            this.uploadModal.fileName = ''
            this.uploadModal.uriPath = ''
            this.uploadModal.hasError = false
            this.uploadModal.errorMessage = ''
        },
        handleUploadOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()
            this.uploadModal.errorMessage = ''
            this.uploadModal.hasError = false
            // Trigger submit handler
            this.handleSubmit()
        },
        handleSubmit() {
            const self = this
            this.model.attachments.push({
                description: `Anexo ${this.model.attachments.length + 1}`,
                fileName: this.uploadModal.fileName,
                uriPath: this.uploadModal.uriPath,
                id: 0,
                moneyOutId: self.id
            })
            self.$nextTick(() => {
                self.$refs.modal.hide()
            })
        },
        onCustomActionClick(row) {
            _.pullAt(this.model.attachments, row.index)
            this.$refs.table.refresh()
        },
        saveAttachments() {
            const self = this
            self.showLoading()
            let entity = {
                id: self.id,
                receipts: self.model.attachments
            };
            domainService.saveAttachments(entity).then(() => {
                self.hideLoading()
                self.fetchData()
            })
        }
    }
}
</script>
<style scoped>
.form-control-plaintext {
    font-weight: bold !important;
}
</style>
